import { AfterViewChecked, Component, Input, ViewChild } from '@angular/core';
import { IonTextarea, ModalController } from '@ionic/angular';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { ToastColor, ToastService } from '@services/toast/toast.service';
import { MyEquipmentService } from '@techwan/ionic-core';
import { Observable } from 'rxjs';
import { MediaMessageProxyService } from '../../services/media-message-proxy/media-message-proxy.service';

@Component({
  templateUrl: 'media-message-text-editor.component.html',
  styleUrls: ['media-message-text-editor.component.scss']
})
export class MediaMessageTextEditorComponent implements AfterViewChecked {
  @Input()
  callcard: CallCard;

  @ViewChild('textAreaMessage')
  textArea: IonTextarea;

  private CREATE_ALARM_TIMEOUT: number = 5000;
  MAX_TEXT_LENGTH: number = 1024;

  text: string = '';

  constructor(
    private modalCtrl: ModalController,
    private toastService: ToastService,
    private myEquipmentService: MyEquipmentService,
    private mediaTextProxy: MediaMessageProxyService
  ) {}

  ngAfterViewChecked() {
    this.textArea.setFocus();
  }

  createMessage(text: string) {
    const responseTimer = setTimeout(() => {
      this.requestErrorHandling();
    }, this.CREATE_ALARM_TIMEOUT);

    this.save(text).subscribe(
      response => {
        clearTimeout(responseTimer);
        this.close();
      },
      error => {
        clearTimeout(responseTimer);
        this.requestErrorHandling();
      }
    );
  }

  private save(text: string): Observable<boolean> {
    const data = {
      ParentMessageUid: this.myEquipmentService.myUnit.ObjGuid,
      CallCardId: this.callcard.ObjGuid,
      Text: text,
      Caption: this.myEquipmentService.myDevice.Name,
      Owner: this.callcard.Owner
    };

    return this.mediaTextProxy.createText(data);
  }

  private requestErrorHandling() {
    this.toastService.show('Mobile.ErrorDuringSending', ToastColor.Error);
  }

  close() {
    this.modalCtrl.dismiss();
  }
}
